import {
  BatchOrderAcceptLedgerConditionListItem,
  BatchOrderAcceptLedgerConditionListItemFromJSON
} from '@/api/models/batch/BatchOrderAcceptLedgerConditionListItem'

export interface BatchOrderAcceptLedgerPageLoadResult {
  items: BatchOrderAcceptLedgerConditionListItem
}

export function BatchOrderAcceptPageLoadResultFromJSON(
  json: any
): BatchOrderAcceptLedgerPageLoadResult {
  return {
    items: BatchOrderAcceptLedgerConditionListItemFromJSON(json)
  }
}
